import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

export default function Title({ text }: { text: string }) {
  return (
    <MDBox
      bgColor="#f5f5f5"
      py={2}
      px={4}
      sx={{
        "@media print": {
          paddingLeft: "8px",
        },
      }}
    >
      <MDTypography variant="h4" sx={{ fontSize: "1rem", lineHeight: 1.2, color: "#000" }}>
        {text}
      </MDTypography>
    </MDBox>
  );
}
